import {Rectangle, type RectangleProps} from 'recharts';

import {getDocumentBarRadius} from './getDocumentBarRadius';

interface DocumentStackedBarShapeProps extends RectangleProps {
  /** A horizontal stack rounds its right-hand end, a vertical one its top. */
  isHorizontal: boolean;
  seriesCount: number;
  seriesIndex: number;
  /** Set by Recharts: the data point of the segment. */
  payload?: unknown;
}

/** Segment of a stacked bar that rounds only the outer end of its stack. */
export function DocumentStackedBarShape(props: DocumentStackedBarShapeProps) {
  return (
    <Rectangle
      {...props}
      radius={getDocumentBarRadius(props.isHorizontal, {
        point: props.payload,
        seriesCount: props.seriesCount,
        seriesIndex: props.seriesIndex,
      })}
    />
  );
}
